module.exports = __webpack_public_path__ + "static/vmware_18.634e0846.jpg";